// extracted by mini-css-extract-plugin
export default {"mainMenu__link__sub":"SubMenuAbout_mainMenu__link__sub__B+OMx","subMenu__about":"SubMenuAbout_subMenu__about__GL1Y5","active":"SubMenuAbout_active__ALlVX"};